import * as actionTypes from "./actionTypes";

export const setCurrency = (value) => {
  return {
    type: actionTypes.SET_CURRENCY,
    value,
  };
};
